export default "/_next/static/media/SourceSansProLight.cc23c7d88e6214f2d9281d2fda8885fd.woff2";